export default {
  invoices: [],
  transaction: null
}
